module.exports = __webpack_public_path__ + "static/media/notification.c0d3c94c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/notification.eot
// module id = 65
// module chunks = 0